/* tslint:disable */
/* eslint-disable */
/**
 * Xerjoff.Agenti.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MeResponseDTO
 */
export interface MeResponseDTO {
    /**
     * 
     * @type {string}
     * @memberof MeResponseDTO
     */
    givenName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeResponseDTO
     */
    surname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeResponseDTO
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeResponseDTO
     */
    piva?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeResponseDTO
     */
    ragioneSociale?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeResponseDTO
     */
    indirizzo?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeResponseDTO
     */
    cap?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeResponseDTO
     */
    citta?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeResponseDTO
     */
    telefono?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeResponseDTO
     */
    mobile?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeResponseDTO
     */
    emailAgente?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeResponseDTO
     */
    pec?: string | null;
}

/**
 * Check if a given object implements the MeResponseDTO interface.
 */
export function instanceOfMeResponseDTO(value: object): value is MeResponseDTO {
    return true;
}

export function MeResponseDTOFromJSON(json: any): MeResponseDTO {
    return MeResponseDTOFromJSONTyped(json, false);
}

export function MeResponseDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): MeResponseDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'givenName': json['givenName'] == null ? undefined : json['givenName'],
        'surname': json['surname'] == null ? undefined : json['surname'],
        'email': json['email'] == null ? undefined : json['email'],
        'piva': json['piva'] == null ? undefined : json['piva'],
        'ragioneSociale': json['ragioneSociale'] == null ? undefined : json['ragioneSociale'],
        'indirizzo': json['indirizzo'] == null ? undefined : json['indirizzo'],
        'cap': json['cap'] == null ? undefined : json['cap'],
        'citta': json['citta'] == null ? undefined : json['citta'],
        'telefono': json['telefono'] == null ? undefined : json['telefono'],
        'mobile': json['mobile'] == null ? undefined : json['mobile'],
        'emailAgente': json['emailAgente'] == null ? undefined : json['emailAgente'],
        'pec': json['pec'] == null ? undefined : json['pec'],
    };
}

  export function MeResponseDTOToJSON(json: any): MeResponseDTO {
      return MeResponseDTOToJSONTyped(json, false);
  }

  export function MeResponseDTOToJSONTyped(value?: MeResponseDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'givenName': value['givenName'],
        'surname': value['surname'],
        'email': value['email'],
        'piva': value['piva'],
        'ragioneSociale': value['ragioneSociale'],
        'indirizzo': value['indirizzo'],
        'cap': value['cap'],
        'citta': value['citta'],
        'telefono': value['telefono'],
        'mobile': value['mobile'],
        'emailAgente': value['emailAgente'],
        'pec': value['pec'],
    };
}

